import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export const HeroSection = () => {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-darker" data-id="element-101">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-102">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-103">
          <div data-id="element-104">
            <FadeIn data-id="element-105">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-106">
                Batidos de Energía 7x7:{' '}
                <span className="text-brand-green" data-id="element-107">
                  Recarga Tu Cuerpo en 7 Días
                </span>
              </h1>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-108">
              <h2 className="text-xl md:text-2xl font-medium text-gray-300 mb-6" data-id="element-109">
                7 Batidos con Frutas y Vegetales para Cada Día de la Semana y
                Más Energía Natural
              </h2>
            </FadeIn>
            <FadeIn delay={0.4} data-id="element-110">
              <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-111">
                Te levantas cansado. Miras el reloj. Y sabes que el día será una
                batalla cuesta arriba. Pero, ¿y si en 5 minutos tuvieras un
                batido diseñado específicamente para darte el impulso que
                necesitas? Eso es exactamente lo que te entrega este bundle.
              </p>
            </FadeIn>
            <FadeIn delay={0.6} data-id="element-112">
              <Button data-id="element-113">¡Quiero Mis Batidos Ahora!</Button>
            </FadeIn>
          </div>
          <FadeIn delay={0.4} className="relative" data-id="element-114">
            <div className="absolute inset-0 bg-brand-green rounded-2xl blur-3xl opacity-20" data-id="element-115"></div>
            <div className="relative w-full flex items-center justify-center" data-id="element-116">
              {/* Hexagonal glow behind */}
              <div className="absolute inset-0 bg-brand-green opacity-15 blur-2xl" style={{
              clipPath: 'polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%)'
            }} data-id="element-117"></div>

              {/* Hexagonal border frame */}
              <svg viewBox="0 0 400 440" className="absolute inset-0 w-full h-full z-20 pointer-events-none" xmlns="http://www.w3.org/2000/svg" data-id="element-118">
                <defs data-id="element-119">
                  <linearGradient id="hexBorder" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-120">
                    <stop offset="0%" stopColor="#4ade80" stopOpacity="0.8" data-id="element-121" />
                    <stop offset="50%" stopColor="#22c55e" stopOpacity="0.4" data-id="element-122" />
                    <stop offset="100%" stopColor="#4ade80" stopOpacity="0.8" data-id="element-123" />
                  </linearGradient>
                  <filter id="hexGlow" data-id="element-124">
                    <feGaussianBlur stdDeviation="4" result="blur" data-id="element-125" />
                    <feMerge data-id="element-126">
                      <feMergeNode in="blur" data-id="element-127" />
                      <feMergeNode in="SourceGraphic" data-id="element-128" />
                    </feMerge>
                  </filter>
                </defs>
                <polygon points="200,8 372,110 372,330 200,432 28,330 28,110" fill="none" stroke="url(#hexBorder)" strokeWidth="3" filter="url(#hexGlow)" data-id="element-129" />
                {/* Inner subtle border */}
                <polygon points="200,16 364,114 364,326 200,424 36,326 36,114" fill="none" stroke="#4ade80" strokeWidth="1" opacity="0.2" data-id="element-130" />
              </svg>

              {/* Hexagonal image */}
              <div className="relative z-10 w-full aspect-[10/11]" data-id="element-131">
                <img src="https://cdn.magicpatterns.com/uploads/amn5XTRYfkYgKsyYPT4Xr3/IMG_9830.jpg" alt="Combinaciones de Jugos Naturales - Game Changing Juices" className="w-full h-full object-cover bg-[#7CF525] pt-[68px] pb-[68px]" style={{
                clipPath: 'polygon(50% 2%, 93% 25%, 93% 75%, 50% 98%, 7% 75%, 7% 25%)'
              }} data-id="element-132" />
                {/* Dome glass overlay effect */}
                <div className="absolute inset-0 pointer-events-none" style={{
                clipPath: 'polygon(50% 2%, 93% 25%, 93% 75%, 50% 98%, 7% 75%, 7% 25%)',
                background: 'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 40%, transparent 60%, rgba(0,0,0,0.2) 100%)'
              }} data-id="element-133"></div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};